<template>
  <el-dialog width="480px" class="dialog" title="预约日期选择" :visible.sync="dialogFormVisible">
    <el-form ref="ruleForm" label-position="right" :rules="rules" :model="formData" label-width="120px">
      <el-form-item label="预约日期" prop="appointTime">
        <el-date-picker
          v-model="formData.appointTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          placeholder="请选择需要预约的日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      /**
       * dialogFormVisible 弹框状态
       * formData 表单数据
       * rules 表单规则
       */
      dialogFormVisible: false,
      formData: {
        appointTime: ''
      },
      rules: {
        appointTime: [
          { required: true, message: '请选择预约日期', trigger: 'blur' },
        ]
      },
      pickerOptions: {
        disabledDate: (date) => {
          const currentDate = new Date();
          // 将当前日期时间设置为00:00:00
          currentDate.setHours(0, 0, 0, 0);
          // 禁用选择过去的日期
          return date < currentDate;
        },
      },
      btnLoading: false
    }
  },
  methods: {
    // 关闭弹框
    closeDialog () {
      this.dialogFormVisible = false
    },
    // 打开弹框
    openDialog (orderNums) {
      this.formData.orderNums = orderNums || ''
      this.dialogFormVisible = true
    },
    // 确认提交
    submitBtnFun () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          this.submitReq()
        } else {
          console.log('error submit!!')
          return false;
        }
      })
    },
    // 请求提交
    submitReq () {
      const url = `/autoapp-default-server-recovery/api/tblRecycleOrder/batchReserve`
      // 获取当前时分秒
      let date = new Date()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      // 选中年月日拼接当前时分秒
      let totalTime = this.formData.appointTime +' ' + hour + ':' + minute + ':' + second
      console.log('打印预约时间',this.formData.appointTime, new Date(), hour, minute, second,totalTime)
      let params = {}
      // params.appointmentTime = new Date(this.formData.appointTime).toISOString()
      params.appointmentTime = new Date(totalTime).toISOString()
      params.orderNums = this.formData.orderNums
      this.HttpService.post(url, params).then(res => {
        this.btnLoading = false
        if (res.statusCode === 200) {
          this.$message.success('预约成功')
          this.$emit('opera-success')
          this.resetFormStatus()
          this.closeDialog()
        } else {
          const tipMsg = res.message || '预约失败'
          this.$message.error(tipMsg)
        }
      })
    },
    // 表单重置
    resetFormStatus () {
      this.$refs.ruleForm.resetFields()
    }
  }
}
</script>
<style scoped lang='scss'>
.dialog {
  padding: 20px;

  .dialog-footer {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/AppointTimeSelDialog.vue